import React from "react";
import { DefaultDataTable } from "../../../components/dataTable/DefaultDataTable";

export const AcaoList = props => <DefaultDataTable data={props} />;
